"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.determineRequest = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _utils = require("@insided/shared/uikit/Editor/Attachments/utils");

var _axios = _interopRequireDefault(require("axios"));

var _common = require("@insided/shared/utils/common");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var newPost = function newPost() {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(content, attachments, hasFileInProgress) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0, _utils.checkAttachments)(hasFileInProgress);
              _context.next = 3;
              return _axios.default.post(window.location.pathname.split('?')[0], {
                pagetext: content,
                attachments: attachments
              });

            case 3:
              return _context.abrupt("return", _context.sent);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};

var editPost = function editPost(topicId, postId) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(content, attachments, hasFileInProgress) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              (0, _utils.checkAttachments)(hasFileInProgress);
              _context2.next = 3;
              return _axios.default.post('/post/edit', {
                NewPostForm: {
                  pagetext: content
                },
                attachments: attachments
              }, {
                params: {
                  postid: postId,
                  tid: topicId
                }
              });

            case 3:
              return _context2.abrupt("return", _context2.sent);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var newPostDestination = function newPostDestination(topicId, parentId, sort) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(content, attachments, hasFileInProgress) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              (0, _utils.checkAttachments)(hasFileInProgress);
              _context3.next = 3;
              return _axios.default.post('/post/save', {
                post: {
                  content: content
                },
                attachments: attachments,
                parentId: parentId
              }, {
                params: _objectSpread({
                  topic_id: topicId
                }, sort ? {
                  sort: sort
                } : {})
              });

            case 3:
              return _context3.abrupt("return", _context3.sent);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x7, _x8, _x9) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var editPostDestination = function editPostDestination(topicId, postId, sort) {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(content, attachments, hasFileInProgress) {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              (0, _utils.checkAttachments)(hasFileInProgress);
              _context4.next = 3;
              return _axios.default.post('/post/update', {
                post: {
                  content: content
                },
                attachments: attachments
              }, {
                params: _objectSpread({
                  post_id: postId,
                  tid: topicId
                }, sort ? {
                  sort: sort
                } : {})
              });

            case 3:
              return _context4.abrupt("return", _context4.sent);

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x10, _x11, _x12) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var determineRequest = function determineRequest(_ref5) {
  var postId = _ref5.postId,
      isControl = _ref5.isControl,
      topicId = _ref5.topicId,
      parentId = _ref5.parentId;

  var isThreadedRepliesEnabled = _common.common.isModuleActive('threadedRepliesDestination');

  var urlParams = new URLSearchParams(globalThis.location.search);
  var sort = isThreadedRepliesEnabled ? urlParams.get('sort') : undefined;

  if (!isControl) {
    if (postId) return editPostDestination(topicId, postId, sort);
    return newPostDestination(topicId, parentId, sort);
  }

  if (postId) return editPost(topicId, postId);
  return newPost();
};

exports.determineRequest = determineRequest;